import Vue from "vue";
import VueI18n from "vue-i18n";
import pluralizationRules from "./pluralization";

Vue.use(VueI18n);

const messagesRu = {};

const requireLang = require.context("./../../messages", true, /\.json$/);

for (const file of requireLang.keys()) {
  const path = file.replace(/(\.\/|\.json$)/g, "").split("/");
  path.reduce((product, item, index) => {
    if (product[item]) return product[item];
    product[item] = index + 1 === path.length ? requireLang(file) : {};
    return product;
  }, messagesRu);
}

const messages = { ru: messagesRu };

// Соединим словари валидации приложения со словарями veeValidate
const veeValidateContext = require.context(
  "vee-validate/dist/locale",
  true,
  /\.json$/
);
veeValidateContext.keys().forEach(file => {
  const lang = file.replace(/\.\/([^.]+)\.json/g, "$1");
  // Если рассматриваемый язык veeValidate есть в нашем словаре
  // то перезаполним поле Validations с использованием статей veeValidate
  if (Object.prototype.hasOwnProperty.call(messages, lang)) {
    let veeValidations = veeValidateContext(file);
    messages[lang].Validations = {
      ...veeValidations.messages,
      ...messages[lang].Validations
    };
  }
});

// Объект i18n для приложения
const i18n = new VueI18n({
  locale: "ru",
  fallbackLocale: "ru",
  messages,
  pluralizationRules
});

export default i18n;
